<script>
import EntryCollapse from '@wielink-application/shared/vue/layouts/partials/sidebar/entry-collapse.vue'
export default EntryCollapse;
</script>